@if (product?.images) {
  <a [routerLink]="{  cxRoute: 'product',params: product } | cxUrl" class="cx-product-image-container" tabindex="-1">
    <cx-media class="cx-product-image" [container]="product.images?.PRIMARY || product.images" format="product"
    [alt]="product.summary"></cx-media>
  </a>
}
<div class="product-list">


  <a [routerLink]="{  cxRoute: 'product',params: product } | cxUrl" class="cx-product-name">
    @if (product.code) {
      <label class="product-code d-inline" [innerHtml]="product.code"></label>
    }
  </a>

  @if (product.typenumber) {
    <label class="label-style">{{product.typenumber}}</label>
  }

  @if (product.name) {
    <label class="label-style" [innerHtml]="product.name"></label>
  }
  @if (product?.sapEan) {
    <label class="label-style">GTIN : {{product?.sapEan}}</label>
  }
  <label class="label-style"
    [ngClass]="product.salesStatusCode=='CODE30' || product.salesStatusCode=='CODE40' ||product.salesStatusCode=='code30' || product.salesStatusCode=='code40'?'':''">
    @if (product.salesStatus?.indexOf('common.')<0) {
      <span>{{product.salesStatus}}</span>
    }
    @if (product.salesStatus?.indexOf('common.')>-1) {
      <span>{{product.salesStatus|cxTranslate}}</span>
    }
  </label>
  @if (product?.typenumber) {
    <label class="label-style">{{product?.marketType}}</label>
  }

</div>
<ng-template [cxOutlet]="ProductListOutlets.ITEM_ACTIONS">
  <ng-container cxInnerComponentsHost></ng-container>
</ng-template>